import React from "react";
import { Tooltip } from "antd";

import {
  FormItem,
  Input,
  Row,
  Col,
  EyeIcon,
  EyeIconInvisible,
  PasswordValidationList,
  ValidationItem,
  InfoIcon,
  Box,
} from "./styles";

interface PasswordFieldsProps {
  newPassword: string;
  setNewPassword: (value: string) => void;
  confirmPassword: string;
  setConfirmPassword: (value: string) => void;
  showNewPassword: boolean;
  setShowNewPassword: (value: boolean) => void;
  showConfirmPassword: boolean;
  setShowConfirmPassword: (value: boolean) => void;
  passwordValidations: {
    minLength: boolean;
    hasUppercase: boolean;
    hasLowercase: boolean;
    hasNumber: boolean;
    hasSymbol: boolean;
    noSequence: boolean;
    noTBA: boolean;
    noNameParts: boolean;
    noTheBest: boolean;
    passwordsMatch: boolean;
  };
  loading: boolean;
  isPinVerified?: boolean;
}

const PasswordFields: React.FC<PasswordFieldsProps> = ({
  newPassword,
  setNewPassword,
  confirmPassword,
  setConfirmPassword,
  showNewPassword,
  setShowNewPassword,
  showConfirmPassword,
  setShowConfirmPassword,
  passwordValidations,
  loading,
  isPinVerified = true,
}) => {
  return (
    <>
      <Row>
        <Col sm={24} xs={24}>
          <FormItem
            label={
              <span>
                Nova senha{" "}
                <Tooltip title="A senha deve conter no mínimo 6 caracteres, incluir letras maiúsculas e minúsculas, números e símbolos.">
                  <InfoIcon style={{ color: "#1890ff" }} />
                </Tooltip>
              </span>
            }
            name="newPassword"
            rules={[{ required: true, message: "Preencha sua nova senha." }]}
          >
            <Input
              name="newPassword"
              placeholder="Digite sua nova senha"
              autoComplete="new-password"
              type={showNewPassword ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              disabled={loading || !isPinVerified}
              suffix={
                <span onClick={() => setShowNewPassword(!showNewPassword)}>
                  {showNewPassword ? <EyeIcon /> : <EyeIconInvisible />}
                </span>
              }
            />
          </FormItem>

          <PasswordValidationList>
            <Box>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <ValidationItem isValid={passwordValidations.minLength}>
                  Mínimo de 6 caracteres
                </ValidationItem>
                <ValidationItem isValid={passwordValidations.hasUppercase}>
                  Pelo menos 1 letra maiúscula (A-Z)
                </ValidationItem>
                <ValidationItem isValid={passwordValidations.hasLowercase}>
                  Pelo menos 1 letra minúscula (a-z)
                </ValidationItem>
                <ValidationItem isValid={passwordValidations.hasNumber}>
                  Pelo menos 1 número (0-9)
                </ValidationItem>
                <ValidationItem isValid={passwordValidations.noTheBest}>
                  Não pode conter "the best" ou "thebest"
                </ValidationItem>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <ValidationItem isValid={passwordValidations.hasSymbol}>
                  Pelo menos 1 símbolo especial (!@#$%...)
                </ValidationItem>
                <ValidationItem isValid={passwordValidations.noSequence}>
                  Sem sequências numéricas (ex: 123456)
                </ValidationItem>
                <ValidationItem isValid={passwordValidations.noTBA}>
                  Não pode conter "tba"
                </ValidationItem>

                <ValidationItem isValid={passwordValidations.noNameParts}>
                  Não pode conter partes do seu nome
                </ValidationItem>
              </Col>
            </Box>
          </PasswordValidationList>
        </Col>
      </Row>

      <Row>
        <Col sm={24} xs={24}>
          <FormItem
            label="Confirmar senha"
            name="confirmPassword"
            rules={[{ required: true, message: "Confirme sua nova senha." }]}
          >
            <Input
              autoComplete="new-password"
              name="confirmPassword"
              placeholder="Confirme sua nova senha"
              type={showConfirmPassword ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={loading || !isPinVerified}
              suffix={
                <span
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <EyeIcon /> : <EyeIconInvisible />}
                </span>
              }
            />
          </FormItem>

          <ValidationItem isValid={passwordValidations.passwordsMatch}>
            As senhas coincidem
          </ValidationItem>
        </Col>
      </Row>
    </>
  );
};

export default PasswordFields;
